import React, { ReactNode } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import { useAuth } from "../context/AuthContext";
import { useTheme } from "../theme/useTheme";
import { getAppStyles } from "../theme/app-theme";
import "./styles.scss";

interface LayoutProps {
    children: ReactNode;
    routeBack?: string;
}

const Layout: React.FC<LayoutProps> = ({ children, routeBack }) => {
    const { user } = useAuth();
    const { isDarkMode, toggleTheme } = useTheme();
    const styles = getAppStyles(isDarkMode);

    return (
        <div
            className={`app-root ${isDarkMode ? "app-root--dark" : ""}`}
            style={styles.root}
        >
            <Header
                user={{ name: user?.name || "" }}
                routeBack={routeBack}
                isDarkMode={isDarkMode}
                onToggleTheme={toggleTheme}
            />
            <main style={styles.main}>
                {children}
            </main>
            <Footer isDarkMode={isDarkMode} />
        </div>
    );
};

export default Layout;
